import { createFileRoute } from '@tanstack/react-router'

// The leaf that makes the pathless `_report` layout match on bare `/market`; it renders nothing of its own.
export const Route = createFileRoute('/_app/market/_report/')({})
